import * as AlertDialog from '@givebutter/primitives/alert-dialog';
import { useWithdrawFunds } from 'assets/js/pages/payouts/useWithdrawFunds';

const NotEligible = () => {
    const { campaign } = useWithdrawFunds();

    return (
        <div className={'flex flex-col gap-4 text-base'}>
            <AlertDialog.Title>Uh oh. Looks like you can't withdraw these funds.</AlertDialog.Title>
            <p className={'font-medium text-red-500'}>{campaign.payouts.can_payout_bank.reason}</p>
        </div>
    );
};

export { NotEligible };
